import type { CourseLevel } from '@teachur/http-client';

export const DEGREE_LEVEL_OPTIONS: { value: CourseLevel; label: string }[] = [
  { value: 'associate', label: 'Associate' },
  { value: 'bachelor', label: "Bachelor's" },
  { value: 'master', label: "Master's" },
];
